module.exports = __webpack_public_path__ + "img/Award.6299b748.jpg";